var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 124",
    style: {
      enableBackground: "new 0 0 136 124"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFFCFC;}\n\t.st1{opacity:0.7;fill:#EFFCFC;enable-background:new    ;}\n\t.st2{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st3{mask:url(#mask0_1384_3435_00000121968489272458773730000006683784910104513942_);}\n\t.st4{fill:#028383;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.8,2.3c0,0-23.2-7.1-44.5,6.8C21,23.1,11.6,49.2,3.4,70.2c-8.2,21-1.2,41.7,16.5,50.5 c17.6,8.8,28.2-5.8,51.9-7.5s30.4,1.4,49.2-13c18.8-14.5,20.1-46.7,2.9-69.7C106.6,7.4,86.8,2.3,86.8,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.8,2.3c0,0-23.2-7.1-44.5,6.8C21,23.1,11.6,49.2,3.4,70.2c-8.2,21-1.2,41.7,16.5,50.5 c17.6,8.8,28.2-5.8,51.9-7.5s30.4,1.4,49.2-13c18.8-14.5,20.1-46.7,2.9-69.7C106.6,7.4,86.8,2.3,86.8,2.3z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 41,
    y: 36.7,
    width: 61.6,
    height: 59.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 36.7,
    width: 61.6,
    height: 59.5,
    id: "mask0_1384_3435_00000121968489272458773730000006683784910104513942_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 26.8,
    className: "st2",
    width: 85,
    height: 84.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.6,37.4l26.8,15.8c0.4,0.3,0.7,0.6,0.9,1s0.4,0.8,0.4,1.3v35.4c0,1.5-0.5,2.8-1.5,3.8 c-1,1-2.3,1.5-3.8,1.5h-51c-1.5,0-2.8-0.5-3.8-1.5S41,92.4,41,90.9V55.5c0-0.5,0.1-0.9,0.4-1.3c0.2-0.4,0.5-0.7,0.9-1l26.8-15.8 c0.8-0.5,1.7-0.7,2.7-0.7C72.8,36.7,73.7,36.9,74.6,37.4z M73.2,70.5L99.4,55L73.2,39.5c-0.5-0.3-0.9-0.4-1.4-0.4 s-0.9,0.1-1.4,0.4L44.2,55l26.2,15.5c0.5,0.3,0.9,0.4,1.4,0.4S72.8,70.8,73.2,70.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEmailIcon);
export default __webpack_public_path__ + "static/media/loginEmailIcon.38e42362b5c865234a7f1e94f941e7df.svg";
export { ForwardRef as ReactComponent };